<template>
  <ul id="accordion" class="custom-scrollbar_">
    <li>
      <ul class="accordion collapsible collapsible-accordion">
        <li class="menuMain"><router-link to="/home" class="collapsible-header waves-effect text-bold active"><i
              class="sv-slim-icon fas fa-dashboard"></i><label class="main">Dashboard</label></router-link></li>
        <!---->
        <li class="menuMain"><a id="account-menu" type="button" data-toggle="collapse" data-target="#account"
            aria-expanded="false" aria-controls="management" class="collapsible-header waves-effect text-bold"
            style="width: 100%;"><i class="sv-slim-icon fas fa-member"></i><label class="main">Account</label><i
              class="fas fa-angle-down rotate-icon"></i></a>
          <div id="account" data-parent="#accordion" class="collapse">
            <ul>
              <li><router-link id="profile-item" to="/profile" class="waves-effect text-bold"><span
                    class="sv-normal submain">Profile</span></router-link></li>
              <li><router-link id="change-password-item" to="/change-password" class="waves-effect text-bold"><span
                    class="sv-normal submain">Password</span></router-link></li>
              <li v-if="UsersInfo.roles[0] != 'SUBACCOUNT'"><router-link id="change-password-item" to="/payout-setting"
                  class="waves-effect text-bold"><span class="sv-normal submain">Payout Setting</span></router-link></li>
            </ul>
          </div>
        </li>
        <li class="menuMain"><a id="managment-menu" type="button" data-toggle="collapse" data-target="#management"
            aria-expanded="false" aria-controls="management" class="collapsible-header waves-effect text-bold"
            style="width: 100%;"><i id="s-managment" class="sv-slim-icon fas fa-member"></i><label
              class="main">Management</label><i class="fas fa-angle-down rotate-icon"></i></a>
          <div id="management" data-parent="#accordion" class="collapse">
            <ul>
              <!---->
              <li v-if="UsersInfo.roles[0] == 'MASTER' || UsersInfo.roles[0] == 'SENIOR' || UsersInfo.roles[0] == 'COMPANY'"><router-link
                  to="/agent/addagent" r id="add-agent-item" class="waves-effect text-bold"><span
                    class="sv-normal submain">Add Agent</span></router-link></li>
              <li><router-link to="/agent/agentlist" id="list-agent-item" class="waves-effect text-bold"><span
                    class="sv-normal submain">Members &amp; Agents</span></router-link></li>
              <li v-if="UsersInfo.roles[0] != 'SUBACCOUNT'"><router-link id="add-sub-account-item"
                  to="/member/add-sub-account" class="waves-effect text-bold"><span class="sv-normal submain">Add Sub
                    Account</span></router-link></li>
              <li v-if="UsersInfo.roles[0] != 'SUBACCOUNT'"><router-link id="sub-account-item" to="/member/sub-account"
                  class="waves-effect text-bold"><span class="sv-normal submain">Sub Account</span></router-link></li>
            </ul>
          </div>
        </li>
        <li class="menuMain"><a id="report-menu" type="button" data-toggle="collapse" data-target="#report"
            aria-expanded="false" aria-controls="report" class="collapsible-header waves-effect text-bold"
            style="width: 100%;"><i class="sv-slim-icon far fa-report"></i><label class="main">Report</label><i
              class="fas fa-angle-down rotate-icon"></i></a>
          <div id="report" data-parent="#accordion" class="collapse">
            <ul>
              <li><router-link to="/report/winLose" id="win-lose-item" class="waves-effect text-bold"><span
                    class="sv-normal submain">W/L Report</span></router-link></li>
              <li><router-link to="/report/game" id="win-lose-item" class="waves-effect text-bold"><span
                    class="sv-normal submain">W/L Game</span></router-link></li>
            </ul>
          </div>
        </li>
        <li class="menuMain"><a id="payment-menu" type="button" data-toggle="collapse" data-target="#payment"
            aria-expanded="false" aria-controls="payment" class="collapsible-header waves-effect text-bold"
            style="width: 100%;"><i class="sv-slim-icon fas fa-payment"></i><label class="main">Payment</label><i
              class="fas fa-angle-down rotate-icon"></i></a>
          <div id="payment" data-parent="#accordion" class="collapse">
            <ul>
              <li><router-link to="/payment/transfer" id="transfer-item" class="waves-effect text-bold"><span
                    class="sv-normal submain">Deposit / Withdrawal</span></router-link></li>
              <li><router-link to="/payment/statement" id="statement-item" class="waves-effect text-bold"><span
                    class="sv-normal submain">Statement</span></router-link></li>
            </ul>
          </div>
        </li>
        <li class="menuMain"><a href="https://doc.ambsuperapi.com/" target="_blank" id="api-doc-menu"
            class="collapsible-header waves-effect text-bold"><i class="sv-slim-icon far fa-payout-rates"></i><label
              class="main">API Document</label></a></li>
      </ul>
    </li>
  </ul>
</template>

<script>
import MenuJSON from '../config/Menu.json';

export default {
  name: "Navbar",
  props: ["UsersInfo"],
  data() {
    return {
      Menu: MenuJSON,
    }
  },
};
</script>